import React from 'react'
import { useTranslation } from 'react-i18next'

import { CSI_DASHBOARD_PATH } from 'csiDashboard'
import { CSI_SEARCH_PATH } from 'csiDashboard/csiSearch/searchCustomers'

import localStorage, { sessionStore } from 'core/application/commons/localStorage'

import Button from 'common/components/general/Button'

import { ROUTE_PATHS } from './common/routePaths'

export const exitImpersonation = () => {
  const impersonatorToken = localStorage.getImpersonatorToken()
  localStorage.setImpersonatorToken('')
  localStorage.setToken(impersonatorToken ?? '')
  const searchedCompanyId = localStorage.getSearchedCompanyId()
  const searchedCompanyName = localStorage.getSearchedCompanyName()
  localStorage.setSearchedCompanyId('')
  localStorage.setSearchedCompanyName('')
  window.location.href = `${ROUTE_PATHS.CSI_COMPANY_DETAILS}/${searchedCompanyId}?companyName=${searchedCompanyName}`
}

const ImpersonateHint: React.FC = () => {
  const { t: translate } = useTranslation()
  const sessionToken = sessionStore.getSessionToken()

  return sessionToken ? (
    <div className="impersonation_hint  flex flex__center p-16">
      <div className="mr-40">
        <h5 className="color-gray-2">{translate('general.impersonate-mode')}</h5>
      </div>
    </div>
  ) : null
}

export default ImpersonateHint
